"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHyrosApi = void 0;
var tslib_1 = require("tslib");
var withHttpClient_1 = require("../hocs/withHttpClient");
var hyrosApi = function (_a) {
    var httpClient = _a.httpClient;
    var createOrder = function (_a) {
        var orderId = _a.orderId, email = _a.email, productName = _a.productName, productSky = _a.productSky, orderPrice = _a.orderPrice, quantity = _a.quantity;
        return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, httpClient.post({
                            endpoint: "orders",
                            data: {
                                email: email,
                                orderId: orderId,
                                priceFormat: 'DECIMAL',
                                items: [
                                    {
                                        name: productName,
                                        price: orderPrice,
                                        externalId: productSky,
                                        quantity: quantity || 1,
                                    },
                                ],
                            },
                        })];
                    case 1:
                        _b.sent();
                        return [2];
                }
            });
        });
    };
    return {
        createOrder: createOrder,
    };
};
var createHyrosApi = function (apiToken) {
    return (0, withHttpClient_1.withHttpClient)(hyrosApi)({
        baseUrl: 'https://api.hyros.com/v1/api/v1.0/',
        defaultHeaders: { 'API-Key': apiToken },
    });
};
exports.createHyrosApi = createHyrosApi;
